export default __webpack_public_path__ + "static/media/close_modal-course.2c5abaf4.svg";